import React from 'react';
import {useDropzone} from 'react-dropzone';
import './Dropzone.css';
import {useFileContext} from 'context/FileContext';
import {encryptAndUpload} from 'components/upload/encryptAndUpload';
import {Box} from '@mui/material';
import {useAuthContext} from 'context/AuthContext';

export function Dropzone() {
   const {publicArmoredKey, refetchFolder, currentFolder} = useFileContext();
   const {
      authData: {enforcePgp},
   } = useAuthContext();

   const {getRootProps, getInputProps, isDragActive, isDragReject} = useDropzone({
      multiple: true,
      //   accept: {'image/*': []},
      onDrop: (accepted) => {
         console.debug(' drop', accepted);
         const files = accepted;
         Array.from(files).forEach((file) => {
            encryptAndUpload(
               file,
               publicArmoredKey,
               refetchFolder,
               currentFolder!.path,
               enforcePgp
            );
            // uploadFileStream(file, publicArmoredKey, refetchFolder);
         });
      },
   });

   return (
      <Box
         {...getRootProps({
            className: `
    dropzone
    ${isDragReject ? 'dropzone-reject' : ''}
    ${isDragActive ? 'dropzone-active' : ''}
  `,
         })}
      >
         <input {...getInputProps()} />

         {isDragReject ? (
            <p>Unsupported file type</p>
         ) : isDragActive ? (
            <p>Drop here ✨</p>
         ) : (
            <p>Drag & drop files here, or click to select</p>
         )}
      </Box>
   );
}
